import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'

import './lib/debug/otel-web'
import './lib/debug/error-reporter'
import { DebugErrorBoundary } from './lib/debug/ErrorBoundary'


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>

      <DebugErrorBoundary>
        <App />
      </DebugErrorBoundary>

    </QueryClientProvider>
  </React.StrictMode>,
)